
import { defineComponent, ref } from "vue";
import Icon from "../components/Icon.vue";
import Tabs from "../components/Tabs.vue";
import { debounce } from "../utils/debounce";

export enum Filter {
  name = "name",
  gender = "gender",
  species = "species",
}

type FilterOption = { value: Filter; title: string };

export default defineComponent({
  name: "AppNavigation",
  emits: ["onSearch"],
  setup(_, context) {
    const search = ref("");
    const selectedFilter = ref<FilterOption>({
      value: Filter.name,
      title: "Name",
    });
    const isDropdownActive = ref(false);
    const filterOptions = [
      { value: Filter.name, title: "Name" },
      { value: Filter.gender, title: "Gender" },
      { value: Filter.species, title: "Species" },
    ];
    const navLink = [
      { title: "All characters", path: "/" },
      { title: "Favorites", path: "/favorites" },
    ];

    const handleSelect = (filter: FilterOption) => {
      selectedFilter.value = filter;
      context.emit("onSearch", {
        filterBy: filter.value,
        filterValue: search.value,
      });
    };

    const handleDropdownActive = () => {
      isDropdownActive.value = !isDropdownActive.value;
    };

    const onSearch = debounce((e: Event) => {
      const target = e.target as HTMLInputElement;

      search.value = target.value;
      context.emit("onSearch", {
        filterBy: selectedFilter.value.value,
        filterValue: target.value,
      });
    }, 1000);

    return {
      navLink,
      selectedFilter,
      handleSelect,
      filterOptions,
      isDropdownActive,
      handleDropdownActive,
      search,
      onSearch,
    };
  },
  components: { Icon, Tabs },
});
